<mat-form-field
  appearance="fill"
  floatLabel="always"
  subscriptSizing="dynamic"
  [ngClass]="{
    'rkt-FormField--full-width': isFullWidth
  }"
>
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    data-private
    [attr.data-testid]="dataTestId"
    [attr.inputmode]="inputmode"
    [formControl]="formControlRef"
    [type]="hide ? 'password' : 'text'"
  />
  <button
    matSuffix
    mat-icon-button
    aria-label="Password Visibility"
    (click)="hide = !hide"
    [disabled]="formControlRef?.disabled"
  >
    <mat-icon [svgIcon]="hide ? 'visibility-default' : 'visibility_off-default'"></mat-icon>
  </button>
  <mat-error [attr.data-testid]="dataTestId + '-error'">{{ errorMessage }}</mat-error>
</mat-form-field>
